import { APIClient } from "api/api_helper";
import { VERIFICATION_QUEUE_API, SESSION_API } from "api/url_helper";


const api = new APIClient();

export const verificationApiService = {
  getSelectAllData: (studyid: number | null = null) => {
    return api.create(VERIFICATION_QUEUE_API.VERIFICATION_QUEUE_API + "SelectAll", { studyid });
  },

  getSampleCollectionData: (studyid: number, periodid: number, subjectno: string) => {
    return api.create(VERIFICATION_QUEUE_API.NOTIFICATION_COUNT_API + "samplecollection", { studyid, periodid, subjectno });
  },

};
